import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Accordion, Card, Row, Col } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

import toastr from "toastr";

import {
  initialForm,
  initialCapa,
  initialEvidence,
  initialWorkMenInteraction,
  initialObservations,
  VFL_STATUS,
  workmenInteractionRules,
  initialWorkMenInteractionWith,
  observationRules,
} from "./CONSTANTS";

import { UserService } from "app/_services/UserService/UserService";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import { Validation } from "app/_helpers/validation/Validation";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { getCapaOwner } from "app/_services/ehs/ehsCapaOwner";
import { capaRules, evidenceRules } from "../IncidentManagement/CONSTANTS";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getVFLByID, updateVFLByVFLOfficer } from "app/_services/ehs/VFLService";

import WorkmenInteractionTab from "./component/WorkmenInteractionTab";
import ObservationTab, { OBSERVATION_CATEGORY } from "./component/ObservationTab";
import VFLDetailsInfo from "./component/VFLDetailsInfo";
import VFLTimeline from "./component/VFLTimeline";
import VFLScheduleForm from "./component/VFLScheduleForm";
import IncidentEvidences from "../IncidentManagement/IncidentEvidences";
import YesOrNo from "../YesOrNo.component";
import Capas from "../Capas";
import { getAllCategory } from "app/_services/_globalConfiguration/Category/CategoryService";
import { confirmAlert } from "react-confirm-alert";
import { IS_USER_SITE_MINES } from "../IncidentManagement/Helper";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import { getContractor } from "app/_services/Contractor/ContractorService";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { useContractorPersonDropdown } from "app/_helpers/hooks";

const rules = [
  {
    field_name: "vflCompletionDateTime",
    label: "VFL Completion Date",
    type: "string",
    isRequired: true,
  },
];

const VFLCompletionForm = ({
  match: {
    params: { id: incidentDetailsId = null },
  },
  history,
}) => {
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [form, setForm] = useState({
    ...initialForm,
    id: incidentDetailsId,
  });
  const [errorForm, setErrorForm] = useState({
    ...initialForm,
  });
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);

  /*************Tab State *********/

  const [saving, setSaving] = useState(false);

  const [area, setArea] = useState([]);
  const [capaOwners, setCapaOwners] = useState([]);

  // DataBase DATA
  const [sites, setSites] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [activity, setActivity] = useState([]);
  const [subActivity, setSubActivity] = useState([]);

  const [category, setCategory] = useState([]);
  const [contractorPersons, contractorPersonsOption] = useContractorPersonDropdown();
  const [contractors, setContractors] = useState([]);

  const mines = useMemo(() => sites.filter((site) => +site.siteType === 3), [sites]);
  const hoSiteId = useMemo(() => sites.find((site) => +site.siteType === 1)?.id, [sites]);

  /********* WorkmenInteractionTab State *********/
  const [workmenInteraction, setWorkmenInteraction] = useState({
    operationBrief: "",
    workmenUnderstandingOnSafety: "",
    safetyProvidedToWorkmen: "",
    remark: "",
    incidentDetailsId,
    numberOfWorkpersons: 0,
    workmenInteractedWith: [],
  });
  const [workmenInteractionErrors, setWorkmenInteractionErrors] = useState([]);
  const [observationErrors, setObservationErrors] = useState([]);

  /********* ObservationTab State *********/
  const [observation, setObservation] = useState([
    { ...initialObservations, incidentDetailsId },
  ]);

  /********* Evidence State *********/
  const [evidences, setEvidences] = useState([]);
  const [evidencesErrors, setEvidencesErrors] = useState([]);

  /********* Capa State *********/
  // const [capas, setCapas] = useState([]);

  /**************** Form Method ************************/
  const onChange = ({ target: { name, type, value, checked } }) => {
    if (type === "checkbox" && !checked)
      switch (name) {
        // case "workmenInteractionRequired":
        //   if (workmenInteraction?.filter((data) => !data.deleted).length) return toastr.warning("Please delete all rows first!");
        //   break;
        case "observationRequired":
          if (observation?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "evidencesRequired":
          if (evidences?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        // case "capaRequired":
        //   if (capas?.filter((data) => !data.deleted).length)
        //     return toastr.warning("Please delete all rows first!");
        //   break;

        default:
          break;
      }

    setForm((prevForm) => {
      if (name === "insuranceApprovedAmount" && +value > prevForm.insuranceClaimAmount) {
        toastr.warning("Approved amount can not be more than Claim Amount!");
        return prevForm;
      }
      if (name === "insuranceClaimAmount" && +value < prevForm.insuranceApprovedAmount) {
        toastr.warning("Claim amount can not be less than Approved Claim Amount!");
        return prevForm;
      }

      const newForm = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "environmentalImpact" && value === "No")
        newForm.environmentalAssessment = "";
      if (name === "rootCauseAnalysisRequired" && !checked) newForm.rootCause = "";
      if (name === "solutionRequired" && !checked) newForm.solutionType = "";
      if (name === "insuranceClaimAmount" || name === "insuranceApprovedAmount")
        newForm.insuranceUnapprovedAmount =
          +newForm.insuranceClaimAmount - +newForm.insuranceApprovedAmount;
      if (name === "insuranceApplicable") {
        if (checked) {
          newForm.directIncidentLoss = "";
          newForm.insuranceClaimAmount = "";
          newForm.insuranceApprovedAmount = "";
          newForm.insuranceUnapprovedAmount = "";
        } else {
          newForm.insuranceClaimRaised = false;
          newForm.insuranceApplicable = false;
          newForm.directIncidentLossToEquipment = false;
          newForm.directIncidentLoss = 0;
          newForm.insuranceClaimAmount = 0;
          newForm.insuranceApprovedAmount = 0;
          newForm.insuranceUnapprovedAmount = 0;
        }
      }

      return newForm;
    });
  };

  const onChangeDate = (momentDate, name) => {
    if (typeof momentDate === "string") return;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: momentDate.format("YYYY-MM-DD HH:mm:ss"),
    }));
  };

  /*****************************Dependent Data Function ****************/

  const mineDependentData = useCallback(
    (value) => {
      let obj = {};

      obj.regionalOfficeId = mines.find((mine) => mine.id === value)?.parentSite?.name;

      obj.stateMasterId = mines.find((mine) => mine.id === value)?.state?.name;

      obj.countryMasterId = mines.find(
        (mine) => mine.id === value
      )?.state?.country_master?.name;

      setForm((prev) => ({ ...prev, ...obj }));
    },
    [mines]
  );

  const areaDependentData = useCallback(
    (value) => {
      const otherOption = [{ id: 0, name: "Other" }];

      const subAreaData = area.find((x) => x.id === value)?.subAreaOfOperation || [];

      setSubArea(value ? [...subAreaData, ...otherOption] : []);
    },
    [area]
  );

  const activityDependentData = useCallback(
    (value) => {
      const subActivityData = activity.find((x) => x.id === value)?.subActivity || [];
      setSubActivity(subActivityData);
    },
    [activity]
  );

  /********* WorkmenInteractionTab *********/
  const addWorkmenInteraction = () =>
    setWorkmenInteraction((previous) => ({
      ...previous,
      workmenInteractedWith: [
        ...(previous?.workmenInteractedWith || []),
        { ...initialWorkMenInteractionWith },
      ],
    }));

  const deleteWorkmenInteraction = (index) =>
    setWorkmenInteraction((previous) => ({
      ...previous,
      workmenInteractedWith: previous?.workmenInteractedWith
        ?.map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data),
    }));

  const onChangeWorkmenInteraction = ({ name, value, type, checked, index }) => {
    // console.log("name", name);
    // console.log("value", value);

    setWorkmenInteraction((previous) => ({
      ...previous,
      workmenInteractedWith: previous?.workmenInteractedWith?.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      }),
    }));
  };

  const onChangeWorkmen = ({ target: { name, type, value, checked } }) => {
    setWorkmenInteraction((prevForm) => {
      const newForm = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      return newForm;
    });
  };

  /********* ObservationTab *********/
  const addObservation = () =>
    setObservation((previous) => [
      ...previous,
      { ...initialObservations, incidentDetailsId },
    ]);

  const deleteObservation = (index) =>
    setObservation((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );

  const onChangeObservation = ({ name, value, type, checked, index }) => {
    setObservation((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;

        if (name === "categoryId") {
          if (form.areaId !== value) {
            data.subCategoryId = "";
          }
        }
        return data;
      })
    );
  };

  /********* EvidenceTab *********/
  const addEvidence = () =>
    setEvidences((previous) => [...previous, { ...initialEvidence, incidentDetailsId }]);

  const deleteEvidence = (index) =>
    setEvidences((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );

  const onChangeEvidence = ({ name, value, type, checked, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const onChangeEvidenceFile = ({ responseData, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data.file = responseData;
        data.fileId = responseData.id;

        return data;
      })
    );
  };

  /********* CapaTab *********/
  const addCapa = (index) => {
    // setCapas((previous) => ({
    //   ...previous,
    //   [id]: [
    //     ...(previous[id] || []),
    //     {
    //       ...initialCapa,
    //       siteId: form.mineId || "",
    //       // workArea: form.workArea?.name || "",
    //       incidentDetailsId: id,
    //       source: "ehs_vfl_observations",
    //       // areaId: form.areaId,
    //       // subAreaId: form.subAreaId,
    //       otherSubArea: form.otherSubArea,
    //     },
    //   ],
    // }));
    setObservation((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        console.log("adding capa", index, idx);

        if (["safeCondition", "safeAct"].includes(data.type) && !data.deleted) {
          // console.log("++++++", row.type, Array.isArray(row?.capas), row?.capas);
          data["capas"] = [];
          return data;
        }
        console.log("adding capa1", index, idx);
        if (idx !== index) return data;

        data.capas = [
          ...(data?.capas || []),
          {
            ...initialCapa,
            siteId: form.mineId || "",
            // workArea: form.workArea?.name || "",
            // incidentDetailsId: id,
            source: "ehs_vfl_observations",
            // areaId: form.areaId,
            // subAreaId: form.subAreaId,
            otherSubArea: "",
          },
        ];

        return data;
      })
    );
  };
  const deleteCapa = (index, observationIndex) => {
    // setCapas((previous) => ({
    //   ...previous,
    //   [id]: (previous[id] || []).map((data, idx) => (idx !== index ? data : data.id ? { ...data, deleted: 1 } : null)).filter((data) => !!data),
    // }));
    setObservation((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== observationIndex) return data;

        data.capas = data?.capas?.filter((d, i) => i !== index);

        return data;
      })
    );
  };
  const onChangeCapa = ({ name, value, type, checked, index }, observationIndex) => {
    // setCapas((prevCapas) =>
    //   prevCapas.map((data, idx) => {
    //     if (idx !== index) return data;
    //     data[name] = type === "checkbox" ? checked : value;
    //     return data;
    //   })
    // );
    // setCapas((previous) => ({
    //   ...previous,
    //   [id]: (previous[id] || []).map((data, idx) => {
    //     if (idx !== index) return data;
    //     data[name] = type === "checkbox" ? checked : value;
    //     return data;
    //   }),
    // }));

    setObservation((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== observationIndex) return data;

        data.capas = data?.capas?.map((d, i) => {
          if (i !== index) return d;
          if (name === "areaId") {
            d["ownerId"] =
              capaOwners?.find((obj) => value === obj?.areaOfOperationId)?.userId || null;
            d["subAreaId"] = "";
          }
          return { ...d, [name]: type === "checkbox" ? checked : value };
        });

        return data;
      })
    );
  };

  const setFormData = useCallback(() => {
    getVFLByID(incidentDetailsId).then((response) => {
      if (!response?.data) return;

      if (response?.data?.vflStatus === "completed") {
        history.push("/health-safety-and-environment/vfl/manage");
      }
      setForm({
        ...response.data,
        locationSiteId: response.data?.siteData?.siteId,
        roSiteId: response.data?.siteData?.parentSite?.siteId,
        // workmenInteractionRequired: response.data?.workmenInteractionRequired ? true : false,
        // observationRequired: response.data?.observationRequired ? true : false,
        observationRequired: true,
        evidencesRequired: response?.data.evidencesRequired ? true : false,
        // capaRequired: response.data?.capaRequired ? true : false,
      });

      setWorkmenInteraction(response.data.workmen_interactions || workmenInteraction);
      setObservation(
        (response.data.vflObservations?.length &&
          response.data.vflObservations.map((d) => ({ ...d, capas: d.allCapa }))) || [
          { ...initialObservations, incidentDetailsId },
        ]
      );
      // let obj = {};
      // for (const iterator of response.data.vflObservations) {
      //   obj[iterator.id] = iterator.allCapa;
      // }
      // setCapas(obj || {});
      setEvidences(
        (response.data.evidences?.length &&
          response.data.evidences?.filter((data) => data.category === "vfl")) || [
          { ...initialEvidence, incidentDetailsId },
        ]
      );
    });
  }, [incidentDetailsId]);

  /********* onSubmit *********/
  const onSubmit = useCallback(
    async (validate, dontGoBack = false) => {
      if (saving) return;
      setSaving(true);
      const toast = toastr.warning("Saving, please wait...");
      let flag = 0;

      const errorObj = Validation(form, rules);
      let observationObj = JSON.parse(JSON.stringify(observation));

      observationObj.map((row) => {
        if (["safeCondition", "safeAct"].includes(row.type) && !row.deleted) {
          // console.log("++++++", row.type, Array.isArray(row?.capas), row?.capas);
          row["capas"] = [];
          row["capaError"] = [];
          row.capaRequired = "";
        }
        if (!["safeCondition", "safeAct"].includes(row.type) && !row.deleted) {
          row.capaRequired = "";
          if (Array.isArray(row?.capas)) {
            row.capaError = row?.capas.map((data) =>
              data.deleted
                ? {}
                : Validation(
                    data,
                    capaRules?.map((d) =>
                      d?.field_name === "otherSubArea"
                        ? data?.subAreaId === 999
                          ? { ...d, isRequired: true }
                          : { ...d, isRequired: false }
                        : d
                    )
                  )
            );

            if (row?.capas?.length === 0)
              row.capaRequired = "Minimum one row of CAPA is required!";
          } else {
            row.capaRequired = "Minimum one row of CAPA is required!";
          }
        }
      });

      // const workmenInteractionErrorArray = workmenInteraction.map((data) => (data.deleted ? {} : Validation(data, workmenInteractionRules)));

      // const observationErrorArray = observation.map((data) =>
      //   data.deleted ? {} : Validation(data, observationRules)
      // );

      const evidencesErrorArray = form.evidencesRequired
        ? evidences.map((data) => (data.deleted ? {} : Validation(data, evidenceRules)))
        : [];

      // if (form.workmenInteractionRequired && !workmenInteraction.filter((d) => !d.deleted).length)
      //   errorObj.workmenInteractionRequired = "Minimum one row of Workmen Interaction is required!";

      if (form.observationRequired && !observation.filter((d) => !d.deleted).length)
        errorObj.observationRequired = "Minimum one row of observation is required!";

      if (form.evidencesRequired && !evidences.filter((d) => !d.deleted).length)
        errorObj.evidencesRequired = "Minimum one row of Evidence is required!";

      setErrorForm(validate ? errorObj : {});

      // setWorkmenInteractionErrors(workmenInteractionErrorArray);
      // setObservationErrors(observationErrorArray);
      setEvidencesErrors(evidencesErrorArray);

      setObservation(observationObj);

      if (validate) {
        for (const key in errorObj)
          if (errorObj[key]) {
            flag = 1;
            break;
          }
      }

      for (const array of [
        // capasErrorArray,
        evidencesErrorArray,
        // observationErrorArray,
        // workmenInteractionErrorArray,
      ])
        for (const errObj of array)
          for (const key in errObj)
            if (errObj[key]) {
              flag = 1;
            }

      for (const iterator of observationObj) {
        if (iterator?.capaRequired) flag = 1;
        if (Array.isArray(iterator?.capaError))
          for (const err of iterator?.capaError)
            for (const key in err)
              if (err[key]) {
                flag = 1;
                break;
              }
      }

      // console.log("++++++", errorObj);
      // console.log("observationObj", observationObj);
      // console.log("evidencesErrorArray", evidencesErrorArray);

      if (flag !== 0) {
        toastr.clear(toast);
        toastr.warning("Form inputs missing. Please complete all sections.");
        setSaving(false);
        return;
      }

      const response = await updateVFLByVFLOfficer({
        id: form?.id,
        vflId: form?.vflId,
        workMenInteraction: workmenInteraction,
        observations: observation.map((d) => {
          if (
            ["safeCondition", "safeAct"].includes(d.type) &&
            !d.deleted &&
            Array.isArray(d?.capas) &&
            d?.capas.length > 0
          ) {
            // console.log("++++++", d.type, Array.isArray(d?.capas), d?.capas);
            d["capas"] = [];
          }
          return {
            ...d,
            observation: d.observation || null,
            type: d.type || null,
            category: d.category || null,
            subCategory: d.subCategory || null,
            potential: d.potential || null,
            severity: d.severity || null,
          };
        }),
        // capas,
        evidences: form.evidencesRequired ? evidences : [],
        vflStatus: validate
          ? VFL_STATUS.executed === form.vflStatus
            ? VFL_STATUS.capaInProgress
            : VFL_STATUS.executed
          : form?.vflStatus,

        vflCompletionDateTime: form?.vflCompletionDateTime,
        // workmenInteractionRequired: form.workmenInteractionRequired ? 1 : 0,
        observationRequired: form.observationRequired ? 1 : 0,
        evidencesRequired: form.evidencesRequired ? 1 : 0,
        // capaRequired: form.capaRequired ? 1 : 0,
      });

      toastr.clear(toast);

      if (!response?.status) {
        setSaving(false);
        return toastr.error(response?.message);
      }
      if (dontGoBack) setTab((prev) => prev + 1);

      toastr.success(response.message || "Success.");

      setSaving(false);

      if (!dontGoBack) history.push("/health-safety-and-environment/vfl/manage");
      setFormData();
    },
    [evidences, form, history, observation, saving, setFormData, workmenInteraction]
  );

  /************ useEffect*********/
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });
    DepartmentService.getDepartment().then((response) => {
      if (!response?.data) return;

      setDepartments(response.data.departments);
    });
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getAllSites("filter[status]=1&filter[activeStatus]=active").then((response) => {
      if (!response?.data) return;

      setSites(response.data);
    });

    getAllActivity().then((response) => {
      if (!response?.data) return;

      setActivity(response.data);
    });

    getAllCategory(`filter[source]=vfl`).then((response) => {
      if (!response?.data) return;

      setCategory(response.data);
    });

    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  useEffect(() => {
    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwners(
        response.data.capaOwners?.filter((d) => {
          // console.log("getCapaOwner", hoSiteId, d.siteId);
          if (
            (form?.vflAssignerSiteType?.toLowerCase() === "mines" &&
              form?.mineId == d.siteId) ||
            (form?.vflAssignerSiteType?.toLowerCase() != "mines" && hoSiteId == d.siteId)
          )
            return true;

          return false;
        })
      );
    });
  }, [form?.mineId, form?.vflAssignerSiteType, hoSiteId]);

  useEffect(() => {
    if (!incidentDetailsId) return;

    setFormData();
  }, [incidentDetailsId, setFormData]);

  useEffect(() => {
    mineDependentData(form.mineId);
  }, [form.mineId, mineDependentData]);

  useEffect(() => {
    areaDependentData(form.areaId);
  }, [areaDependentData, form.areaId]);

  useEffect(() => {
    activityDependentData(form.activityId);
  }, [activityDependentData, form.activityId]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "VFL",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "VFL Completion" },
        ]}
      />
      <div className="healthSafetyEnvironmentWrapper mt-3">
        <div className="healthSafetyEnvironmentWrapper">
          <div className="hseMenuLinks card pointer">
            <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
              Timeline
            </a>
            <a className={`${tab === 2 ? "active" : ""}`} href onClick={() => setTab(2)}>
              VFL Completion
            </a>
            <a className={`${tab === 3 ? "active" : ""}`} href onClick={() => setTab(3)}>
              Workmen Interaction
            </a>
            <a className={`${tab === 4 ? "active" : ""}`} href onClick={() => setTab(4)}>
              Observations
            </a>
            <a className={`${tab === 5 ? "active" : ""}`} href onClick={() => setTab(5)}>
              Evidence
            </a>
            {/* {form?.vflStatus === VFL_STATUS.executed && ( */}
            <a className={`${tab === 6 ? "active" : ""}`} href onClick={() => setTab(6)}>
              CAPA
            </a>
            {/* )} */}
          </div>
        </div>
      </div>
      <Row>
        <Col lg={9} className="pt-4">
          {tab === 1 && <VFLTimeline form={form} />}

          {tab === 2 && (
            <div className="card p-3 pb-0">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">VFL Completion</h3>
              </div>
              <div className="ehsFormWrapper p-0">
                <VFLScheduleForm
                  form={form}
                  onChange={onChange}
                  onChangeDate={onChangeDate}
                  error={errorForm}
                  mines={mines}
                  area={area}
                  subArea={subArea}
                  activity={activity}
                  subActivity={subActivity}
                  sites={sites}
                  completionFlag
                  vflExecution={form?.vflStatus === VFL_STATUS.executed}
                  contractors={contractors}
                />

                <ButtonsContainer
                  onSubmit={onSubmit}
                  lastTab={13}
                  tab={tab}
                  setTab={setTab}
                />
              </div>
            </div>
          )}

          {tab === 3 && (
            <div className="card p-3 pb-0">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Workmen Interaction</h3>
              </div>
              <div className="ehsFormWrapper p-0">
                <div className="w-100">
                  {/* <Row className="mb-3">
                    <Col lg={8} className="mb-2">
                      <YesOrNo
                        title="Workmen Interaction"
                        name="workmenInteractionRequired"
                        value={form.workmenInteractionRequired ? true : false}
                        onChange={onChange}
                        acceptTitle="Available"
                        rejectTitle="Not Available"
                        disabled={form?.vflStatus === VFL_STATUS.executed}
                      />
                      <span className="small text-danger">{errorForm.workmenInteractionRequired}</span>
                    </Col>
                  </Row> */}
                  {/* {form.workmenInteractionRequired === true && ( */}
                  <WorkmenInteractionTab
                    // dataArray={workmenInteraction}
                    formObj={workmenInteraction}
                    errorArray={workmenInteractionErrors}
                    onChange={onChangeWorkmenInteraction}
                    onAdd={addWorkmenInteraction}
                    onDelete={deleteWorkmenInteraction}
                    viewOnly={form?.vflStatus === VFL_STATUS.executed}
                    onChangeWorkmen={onChangeWorkmen}
                    form={form}
                    contractorsStaff={contractorPersons?.filter(
                      (obj) => obj?.employmentStatus === "active"
                    )}
                  />
                  {/* )} */}
                </div>

                <ButtonsContainer
                  onSubmit={onSubmit}
                  lastTab={13}
                  tab={tab}
                  setTab={setTab}
                />
              </div>
            </div>
          )}

          {tab === 4 && (
            <div className="card p-3 pb-0">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Observations</h3>
              </div>
              <div className="w-100">
                <Row className="mb-3">
                  <Col hidden lg={8} className="mb-2">
                    <YesOrNo
                      title="Observations"
                      name="observationRequired"
                      value={form.observationRequired ? true : false}
                      onChange={onChange}
                      acceptTitle="Available"
                      rejectTitle="Not Available"
                      disabled={form?.vflStatus === VFL_STATUS.executed}
                    />
                    <span className="small text-danger">
                      {errorForm.observationRequired}
                    </span>
                  </Col>
                </Row>
                {form.observationRequired === true && (
                  <ObservationTab
                    // errorArray={observationErrors}
                    category={category}
                    dataArray={observation}
                    onChange={onChangeObservation}
                    onAdd={addObservation}
                    onDelete={deleteObservation}
                    viewOnly={form?.vflStatus === VFL_STATUS.executed}
                  />
                )}
              </div>

              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={13}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}

          {tab === 5 && (
            <div className="card p-3 pb-0">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Evidence</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  <Row className="mb-3">
                    <Col lg={8} className="mb-2">
                      <YesOrNo
                        title="Evidence"
                        name="evidencesRequired"
                        value={form.evidencesRequired ? true : false}
                        onChange={onChange}
                        acceptTitle="Available"
                        rejectTitle="Not Available"
                        disabled={form?.vflStatus === VFL_STATUS.executed}
                      />
                      <span className="small text-danger">
                        {errorForm.evidencesRequired}
                      </span>
                    </Col>
                  </Row>
                  {form.evidencesRequired === true && (
                    <IncidentEvidences
                      dataArray={evidences}
                      errorArray={evidencesErrors}
                      onChange={onChangeEvidence}
                      onChangeFile={onChangeEvidenceFile}
                      onAdd={addEvidence}
                      onDelete={deleteEvidence}
                      viewOnly={form?.vflStatus === VFL_STATUS.executed}
                      isDocumentObj
                    />
                  )}
                </div>
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={6}
                tab={tab}
                setTab={setTab}
              />
            </div>
          )}

          {tab === 6 && (
            <div className="card p-3 pb-0">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">CAPA</h3>
              </div>
              <div className="ehsFormWrapper">
                <div className="w-100">
                  {observation.map((observationObj, observationIndex) => {
                    return (
                      <>
                        {observationObj?.type &&
                          !["safeCondition", "safeAct"].includes(observationObj?.type) &&
                          !observationObj.deleted && (
                            <div className="capaSections">
                              <h3>
                                {
                                  OBSERVATION_CATEGORY.find(
                                    (data) => data.id === observationObj.type
                                  )?.label
                                }
                              </h3>
                              <span className="small text-danger">
                                {observationObj?.capaRequired}
                              </span>
                              <Capas
                                capas={observationObj?.capas}
                                onChangeCapa={(e) => onChangeCapa(e, observationIndex)}
                                addCapa={() => addCapa(observationIndex)}
                                deleteCapa={(index) =>
                                  deleteCapa(index, observationIndex)
                                }
                                users={users}
                                departments={departments}
                                area={area}
                                capaowner={capaOwners.filter((d) => {
                                  // console.log("getCapaOwner", hoSiteId, d.siteId);
                                  if (
                                    (form?.vflAssignerSiteType?.toLowerCase() ===
                                      "mines" &&
                                      form?.mineId == d.siteId) ||
                                    (form?.vflAssignerSiteType?.toLowerCase() !=
                                      "mines" &&
                                      hoSiteId == d.siteId)
                                  )
                                    return true;

                                  return false;
                                })}
                                incidentsOnly
                                capasErrors={observationObj?.capaError}
                                siteId={
                                  form?.vflAssignerSiteType?.toLowerCase() === "mines"
                                    ? form?.mineId
                                    : hoSiteId
                                }
                              />
                            </div>
                          )}
                      </>
                    );
                  })}
                </div>
              </div>
              <ButtonsContainer
                onSubmit={onSubmit}
                lastTab={6}
                tab={tab}
                setTab={setTab}
                noNext
              />
            </div>
          )}

          <div className="mt-4 text-center">
            <span className="btn btn-secondary mx-2" onClick={history.goBack}>
              Go Back
            </span>
          </div>
        </Col>

        <Col lg={3}>
          <div className="mt-4">
            <h5>You are editing as an VFL Officer.</h5>

            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="10"
                  className="rightIncidentCard p-0"
                >
                  <div className="rightInfoTitle">
                    VFL
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <VFLDetailsInfo form={form} />
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </div>
        </Col>
      </Row>
    </>
  );
};

const ButtonsContainer = ({ tab, setTab, lastTab, onSubmit, noNext }) => {
  const onClickVFl = (e) => {
    e.preventDefault();
    confirmAlert({
      title: "VFL Executed",
      message: "Do you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            onSubmit(true);
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };
  return (
    <div className="stepperFormButtons">
      {tab > 1 && (
        <span className="pointer btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
          <BsArrowLeft /> Back
        </span>
      )}
      {tab < lastTab ? (
        <span
          className="pointer btn btn-right"
          onClick={() => {
            // onSubmit(false, true);
            setTab((prev) => prev + 1);
          }}
        >
          Next
          <BsArrowRight />
        </span>
      ) : (
        <span className="pointer btn btn-right" onClick={() => onSubmit(false)}>
          Save
        </span>
      )}
      {noNext && (
        <span className="pointer btn btn-right" onClick={onClickVFl}>
          VFL Executed
        </span>
      )}
    </div>
  );
};

export default VFLCompletionForm;
